// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `quick-panel {
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  z-index: 99;
}
quick-panel .mat-mdc-slide-toggle-content {
  flex: 1;
}
quick-panel .mat-mdc-tab {
  min-width: 20px !important;
  flex: 1 !important;
  padding: 0 !important;
  height: 81px !important;
  margin-bottom: -13px !important;
}
quick-panel .timeline-sidebar {
  padding-left: 10px;
  padding-right: 15px;
}
quick-panel .timeline-sidebar .latest-activity .content .activities .activity {
  padding: 16px 0;
  cursor: pointer;
}
quick-panel .timeline-sidebar .latest-activity .content .activities .activity .avatar {
  margin-right: 16px;
}
quick-panel .timeline-sidebar .latest-activity .content .activities .activity .username {
  font-weight: 600;
}
quick-panel .timeline-sidebar .latest-activity .content .activities .activity .message {
  font-weight: 200;
}
quick-panel .fixed-notification-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/components/quick-panel/quick-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AACF;AAAE;EACE,OAAA;AAEJ;AAAE;EACE,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;AAEJ;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AAGU;EACE,eAAA;EACA,eAAA;AADZ;AAGY;EACE,kBAAA;AADd;AAIY;EACE,gBAAA;AAFd;AAKY;EACE,gBAAA;AAHd;AAWE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AATJ","sourcesContent":["quick-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  width: 350px;\n  min-width: 350px;\n  max-width: 350px;\n  z-index: 99;\n  .mat-mdc-slide-toggle-content {\n    flex: 1;\n  }\n  .mat-mdc-tab {\n    min-width: 20px !important;\n    flex: 1 !important;\n    padding: 0 !important;\n    height: 81px !important;\n    margin-bottom: -13px !important;\n  }\n\n  .timeline-sidebar {\n    padding-left: 10px;\n    padding-right: 15px;\n    .latest-activity {\n      .content {\n        .activities {\n          .activity {\n            padding: 16px 0;\n            cursor: pointer;\n\n            .avatar {\n              margin-right: 16px;\n            }\n\n            .username {\n              font-weight: 600;\n            }\n\n            .message {\n              font-weight: 200;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .fixed-notification-button {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    padding: 10px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
